import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { Stack } from "@similarweb/ui-components/foundations";

import { TopicsFilters } from "app/pages/keyword-research/website-analysis/pages/topics/filters/TopicsFilters";
import { TopicsTableContainer } from "app/pages/keyword-research/website-analysis/pages/topics/TopicsTableContainer";
import {
    buildPageFilterFromKey,
    isPageFilterMatchingKey,
} from "app/pages/keyword-research/website-analysis/pages/topics/utils";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const SearchAdvertisingTopicsPageContainer = () => {
    const { params } = useCurrentStateAndParams();
    const { key, pageFilter = "" } = params;
    const currentKey = key as string;
    const currentPageFilter = pageFilter as string;

    useEffect(() => {
        if (!currentKey) {
            return;
        }

        const isFilterMatchingKey = isPageFilterMatchingKey(currentPageFilter, currentKey);

        if (!isFilterMatchingKey) {
            const newPageFilter = buildPageFilterFromKey(currentKey);
            if (newPageFilter) {
                void proNavigator.updateParams({ pageFilter: newPageFilter }, { reload: false });
            }
        }
    }, [currentKey, currentPageFilter]);

    return (
        <Stack
            width="100%"
            height="100%"
            data-automation="search-advertising-topics-container"
        >
            <TopicsFilters />
            <TopicsTableContainer showKeywordGroupButton={false} />
        </Stack>
    );
};
